import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import about from '@/components/pages/about'
import contact from '@/components/pages/contact'
import experience from '@/components/pages/experience'
import services from '@/components/pages/services'
import notfound from '@/components/notfound'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/experience',
      name: 'experience',
      component: experience
    },
    {
      path: '/services',
      name: 'services',
      component: services
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '*',
      name: notfound,
      component: notfound
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  },
  linkExactActiveClass: 'active',
})



// WEBPACK FOOTER //
// ./src/router/index.js